import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Modal = ({ modalHeight, onClose, children, className = '' }) => {
  return ReactDOM.createPortal(
    <div className={`modal ${className}`}>
      <div className="modal-content" style={{ height: modalHeight || null }}>
        <span className="close" onClick={onClose}>
          &times;
        </span>
        {children}
      </div>
    </div>,
    document.body,
  );
};

Modal.propTypes = {
  modalHeight: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default Modal;
